import React from 'react';
import { Users, BarChart3, Mail, Star, TrendingUp, DollarSign } from 'lucide-react';
import UpcomingTasks from '../../components/dashboard/UpcomingTasks';

const Overview: React.FC = () => {
  const performanceStats = [
    {
      label: 'Total Clients',
      value: '0',
      change: '+0%',
      icon: Users,
      trend: 'up',
    },
    {
      label: 'Conversion Rate',
      value: '0%',
      change: '+0%',
      icon: TrendingUp,
      trend: 'up',
    },
    {
      label: 'Average Revenue',
      value: '$0',
      change: '+0%',
      icon: DollarSign,
      trend: 'up',
    },
    {
      label: 'Active Campaigns',
      value: '0',
      change: '+0',
      icon: BarChart3,
      trend: 'up',
    }
  ];

  return (
    <div className="p-6 space-y-6">
      {/* Performance Analytics */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h2 className="text-lg font-medium text-gray-900 mb-6">Performance Analytics</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {performanceStats.map((stat, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
              <div className="flex items-center justify-between">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <stat.icon className="h-6 w-6 text-blue-600" />
                </div>
                <span className={`text-sm font-medium ${
                  stat.trend === 'up' ? 'text-green-600' : 'text-red-600'
                }`}>
                  {stat.change}
                </span>
              </div>
              <h3 className="text-2xl font-bold mt-4">{stat.value}</h3>
              <p className="text-gray-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Upcoming Tasks (7-Day View) */}
      <UpcomingTasks />

      {/* Performance Chart */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Performance Overview</h3>
        <div className="h-96 flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg">
          <p className="text-gray-500">Chart visualization will be implemented here</p>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Recent Activity</h3>
        <div className="text-gray-500 text-center py-8">
          <p>No recent activity to display</p>
        </div>
      </div>
    </div>
  );
};

export default Overview;